import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import classes from "./DataTableComponent.module.scss";
import SearchIcon from "@mui/icons-material/Search";
import {
  Button,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Pagination from "@mui/material/Pagination";
import dayjs, { Dayjs } from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateRange } from "@mui/x-date-pickers-pro";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { LicenseInfo } from "@mui/x-date-pickers-pro";
import { width } from "@mui/system";
import StyledLoader from "../Styledloader/StyledLoader";

// LicenseInfo.setLicenseKey(
//   'x0jTPl0USVkVZV0SsMjM1kDNyADM5cjM2ETPZJVSQhVRsIDN0YTM6IVREJ1T0b9586ef25c9853decfa7709eee27a1e',
// );

interface Props {
  columns: any;
  checkboxEnabled?: boolean;
  loading?: boolean;
  data: any;
  totalRows?: number;
  handlePageChange?: any;
  pagination?: boolean;
  paginationServer?: boolean;
  paginationCount: any;
  payout?: boolean;
}
const DataTableComponent = ({
  columns,
  checkboxEnabled = false,
  loading = false,
  pagination = false,
  totalRows,
  paginationServer = false,
  handlePageChange,
  paginationCount,
  data = [],
  payout,
}: Props) => {
  const handleChange = (data: any) => {
    // console.log("Selected Rows: ", data.selectedRows);
  };
  const [oldData, setoldData] = useState([]);
  const [query, setQuery] = useState("");
  // const [paginationCount, setpaginationCount] = useState(1);
  const [dataValue, setData] = useState(1);
  const [stageName, setStageName] = useState<any>("");
  const [userId, setUserId] = useState("");
  const [value, setValue] = useState<DateRange<Dayjs>>([
    dayjs().subtract(1, "month"),
    dayjs(),
  ]);

  useEffect(() => {
    setoldData(data);
  }, [data]);
  const handlePaginationChange = (event: any, page: any) => {
    setData(page);
    //console.log( page);
  };

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "rgba(213, 233, 236, 1)",
        borderRadius: "0px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: "0.5px solid rgba(177, 203, 208, 1)",
        marginTop: "-10px",
        borderTop: "none",
      },
    },
    rows: {
      style: {
        borderBottom: "none",
      },
    },
    cells: {
      style: {
        border: "0.5px solid rgba(177, 203, 208, 1)",
        borderBottom: "none",
        display: "flex",
        // background:'red',
        justifyContent: "center",
        alignItems: "center",
      },
    },

    headRow: {
      style: {
        borderBottom: "none",
      },
    },
    header: {
      style: {
        fontSize: "16px",
        borderRadius: "10px 10px 0 0",
        minHeight: "10px",
        paddingLeft: "8px",
        paddingRight: "8px",
        backgroundColor: "rgba(213, 233, 236, 1)",
      },
    },
    contextMenu: {
      style: {
        fontSize: "14px",
        fontWeight: 400,
        borderRadius: "10px",
        paddingLeft: "16px",
        paddingRight: "8px",
        transform: "translate3d(0, -100%, 0)",
        transitionDuration: "125ms",
        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
        willChange: "transform",
      },
      activeStyle: {
        transform: "translate3d(0, 0, 0)",
      },
    },
  };
  return (
    <>
      <div className={classes.tableWrapper}>
        <div className={classes.tableContent}>
          <DataTable
            data={data}
            columns={columns}
            title=" "
            // pagination={pagination}
            highlightOnHover
            selectableRows={checkboxEnabled}
            customStyles={customStyles}
            onSelectedRowsChange={handleChange}
          // fixedHeader
            actions
            progressPending={loading}
            paginationServer={paginationServer}
            progressComponent={<StyledLoader />}
            
          />
        </div>
        {data.length > 0 && !loading && (
          <Stack
            alignItems={"center"}
            // marginTop={data.length >= 9 ? "10px" : "300px"}
            marginTop={"10px"}
            marginBottom={"20px"}
          >
            {!payout && (
              <Pagination
                onChange={(value: any, page: any) => {
                  handlePageChange(value, page);
                }}
                page={paginationCount}
                count={totalRows}
                variant="outlined"
                shape="rounded"
              />
            )}
          </Stack>
        )}
      </div>
    </>
  );
};

export default DataTableComponent;
